// API endpoint paths
import { BASE_URL } from "./config";

export const API_PATHS = {
  users: `${BASE_URL}/users`,
  userProfile: `${BASE_URL}/users/profile`, // GET
  updateProfile: `${BASE_URL}/users/profile`, // PUT
  login: `${BASE_URL}/users/login`, // POST
  forgotPassword: `${BASE_URL}/users/forgot-password`, // POST
  resetPassword: `${BASE_URL}/users/reset-password`, // POST
  regions: `${BASE_URL}/regions`, // GET
  industries: `${BASE_URL}/industries`, // GET
  resumes: `${BASE_URL}/resumes`, // POST
  latestNews: `${BASE_URL}/latestnews`, // GET, POST
  latestNewsById: (id) => `${BASE_URL}/latestnews/${id}`, // GET, PUT, DELETE
  newsletters: `${BASE_URL}/newsletters`, // GET, POST
  newslettersById: (id) => `${BASE_URL}/newsletters/${id}`, // GET, PUT, DELETE
  upcomingEvents: `${BASE_URL}/upcomingevents`, // GET, POST
  upcomingEventsById: (id) => `${BASE_URL}/upcomingevents/${id}`, // GET, PUT, DELETE
  // Social media endpoints
  socialMedia: `${BASE_URL}/socialmedia`, // GET, POST
  socialMediaById: (id) => `${BASE_URL}/socialmedia/${id}`, // GET, PUT, DELETE
  socialMediaUpdates: `${BASE_URL}/socialmediaupdates`, // POST, GET
  socialMediaUpdatesBySocialMediaId: (socialMediaId) => `${BASE_URL}/socialmediaupdates/${socialMediaId}`, // GET
  socialMediaUpdateById: (id) => `${BASE_URL}/socialmediaupdates/${id}`, // GET, PUT, DELETE
  // Contact staff endpoints
  contactStaff: `${BASE_URL}/contactstaff`, // POST, GET
  contactStaffById: (id) => `${BASE_URL}/contactstaff/${id}`, // GET, PUT, DELETE
  contactStaffByRegion: (regionId) => `${BASE_URL}/contactstaff/region/${regionId}`, // GET
  contactUs: `${BASE_URL}/contactus`, // POST
  isFavorite: (id) => `${BASE_URL}/resumes/${id}/favorite`, // PATCH
  updateUserType: (id) => `${BASE_URL}/users/${id}/admin`, // PATCH
  deleteUser: (id) => `${BASE_URL}/users/${id}`, // DELETE
  // Add more endpoints as needed
};
